import React from 'react';
import cancelImage from '../assets/images/cancel.png';
import {
  useChangeColorToDoMutation,
  useChangeStatusToDoMutation,
  useChangeTextToDoMutation,
  useDeleteToDoMutation,
} from '../features/api/apiSlice';
const Todo = ({ todo }) => {
  const { text, completed, color, id } = todo;

  const [deleteToDo] = useDeleteToDoMutation();

  const handleDelete = (e) => {
    e.preventDefault();
    deleteToDo(id);
  };

  const handleStatusChange = (e) => {
    e.preventDefault();

    changeStatusToDo({
      id: id,
      data: {
        text: text,
        color: color,
        completed: !completed,
      },
    });
  };
  const [changeStatusToDo, { data, isloading }] = useChangeStatusToDoMutation();
  const [changeTextToDo] = useChangeTextToDoMutation();
  // change color
  const [changeColorToDo] = useChangeColorToDoMutation();
  const handleColorChange = (id, todocolor) => {
    changeColorToDo({
      id: id,
      data: {
        text: text,
        completed: completed,
        color: todocolor,
      },
    });
  };
  const handleTextChange = (e) => {
    if (e.key === 'Enter') {
      handleTextInput(e);
      alert('updated');
    }
  };
  const handleTextInput = (e) => {
    changeTextToDo({
      id: id,
      data: {
        text: e.target.value,
        completed: completed,
        color: color,
      },
    });
  };
  return (
    <div className="flex justify-start items-center p-2 hover:bg-gray-100 hover:transition-all space-x-4 border-b border-gray-400/20 last:border-0">
      <div
        className={`relative rounded-full bg-white border-2 border-gray-400 w-5 h-5 flex flex-shrink-0 justify-center  items-center mr-2  ${
          completed && 'border-green-500 focus-within:border-green-500'
        }`}
      >
        <input
          type="checkbox"
          checked={completed}
          className="opacity-0 absolute rounded-full"
          onChange={handleStatusChange}
        />
        {completed && (
          <svg
            className="fill-current w-3 h-3 text-green-500 pointer-events-none"
            viewBox="0 0 20 20"
          >
            <path d="M0 11l2-2 5 5L18 3l2 2L7 18z" />
          </svg>
        )}
      </div>

      <input
        defaultValue={text}
        className={`select-none flex-1 ${
          completed && 'line-through'
        } hover:bg-gray-100  py-1 px-1`}
        onKeyDown={handleTextChange}
        onBlur={handleTextInput}
      />

      <div
        className={`flex-shrink-0 h-4 w-4 rounded-full border-2 ml-auto cursor-pointer hover:bg-green-500 border-green-500 ${
          color === 'green' && 'bg-green-500'
        }`}
        onClick={() => handleColorChange(id, 'green')}
      ></div>

      <div
        className={`flex-shrink-0 h-4 w-4 rounded-full border-2 ml-auto cursor-pointer hover:bg-yellow-500 border-yellow-500 ${
          color === 'yellow' && 'bg-yellow-500'
        }`}
        onClick={() => handleColorChange(id, 'yellow')}
      ></div>

      <div
        className={`flex-shrink-0 h-4 w-4 rounded-full border-2 ml-auto cursor-pointer hover:bg-red-500 border-red-500 ${
          color === 'red' && 'bg-red-500'
        }`}
        onClick={() => handleColorChange(id, 'red')}
      ></div>

      <img
        src={cancelImage}
        className="flex-shrink-0 w-4 h-4 ml-2 cursor-pointer"
        alt="Cancel"
        onClick={handleDelete}
      />
    </div>
  );
};

export default Todo;
